import React from 'react';

import ProceedNextStep from '@/components/shared/auth/ProceedNextStep';
import useSignInEmail from '@/components/shared/auth/useSignInEmail';

export type CateringSignInEmailProps = {
  token: string;
};

const CateringSignInEmail: React.FC<CateringSignInEmailProps> = ({ token }) => {
  const { form, onSubmit, back, next, canProceed } = useSignInEmail();

  return (
    <div id="auth-form" className="row-fluid">
      <form className="form-elements" onSubmit={onSubmit}>
        <div className="row-fluid">
          <h4 className="align-left">Email</h4>
          <input
            name="email"
            type="text"
            aria-required="true"
            placeholder={`Enter your login email`}
            className={`${form.errors.email ? 'error' : ''}`}
            autoFocus
            required
            autoComplete="username"
            {...form.getInputProps('email')}
          />
          {form.errors.email ? (
            <p className="register-validation-message">{form.errors.email}</p>
          ) : null}
        </div>
        <div className="row-fluid">
          <button type="submit" className="btn btn-info fooda-colors" disabled={canProceed}>
            {next ? 'Please wait...' : 'Continue'}
          </button>
        </div>
      </form>
      {next ? (
        <ProceedNextStep email={form.values.email} token={token} onError={back} onComplete={back} />
      ) : null}
    </div>
  );
};

export default CateringSignInEmail;
